import styled from "styled-components";

export const TaxModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TaxModalFieldAction = styled.div`
  display: flex;
  justify-content: flex-start;
`;
